import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=ca5dc54c&"
import script from "./PostHeader.vue?vue&type=script&lang=js&"
export * from "./PostHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports